import { loadView } from '@/router'
import consignments from './consignments'
import deliverytimes from './deliverytimes'
import tracking from './tracking'
import quote from './quote'

export default [
  {
    path: 'freight',
    name: 'freight',
    component: loadView('Application/Freight'),
    redirect: {
      name: 'freight-dashboard'
    },
    children: [
      {
        path: 'dashboard',
        name: 'freight-dashboard',
        component: loadView('Application/Freight/Dashboard')
      },
      {
        path: 'edi',
        name: 'freight-edi',
        component: loadView('Application/Manage/EDI')
      },
      {
        path: 'edi-v3',
        name: 'freight-edi-v3',
        component: loadView('Application/Freight/EDI')
      },
      ...consignments,
      ...deliverytimes,
      ...tracking,
      ...quote
    ]
  }
]
